import { translate } from '../../../../../utils/i18n';
import PreBlock from './pre_block';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'ToolParamsJsonView',
  components: {
    PreBlock
  },
  props: {
    toolParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasToolParams() {
      return Object.keys(this.toolParams || {}).length > 0;
    }
  },
  i18n: {
    REQUEST_TEXT: translate('MessageToolApproval.parametersText', 'Request parameters'),
    NO_PARAMETERS_TEXT: translate('MessageToolApproval.noParametersText', 'No parameters will be sent with this request.')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"gl-m-0 gl-flex gl-flex-col gl-gap-2"},[_c('figcaption',{staticClass:"gl-text-subtle"},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.REQUEST_TEXT)+"\n  ")]),_vm._v(" "),(_vm.hasToolParams)?_c('pre-block',{attrs:{"language":"json","data-testid":"tool-parameters"}},[_vm._v(_vm._s(JSON.stringify(_vm.toolParams, null, 2)))]):_c('span',{staticClass:"gl-text-sm gl-text-gray-500",attrs:{"data-testid":"no-parameters-message"}},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.NO_PARAMETERS_TEXT)+"\n  ")])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
